import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../../../lib/api';
import { formatDataOraRoma } from '../../../utils/dateRoma';
import { StatoBuono, TipoBuono, ETICHETTA_TIPO_BUONO, BADGE_STATO_BUONO } from './percorsoTipi';

export interface RiepilogoAcquirente {
  acquirenteId: number;
  origine: 'MANUALE' | 'PAGINA_PUBBLICA';
  venditoreRiferimento: { id: number; nome: string } | null;
  prossimoAppuntamento: string | null;
  buoni: { tipo: TipoBuono; stato: StatoBuono }[];
}

// Riletto quando cambia il numero di acquirenti (aggiunta / eliminazione nella sezione).
// La colonna è accessoria: se la chiamata fallisce si logga e la mappa resta vuota, senza bloccare la commessa.
export function useRiepilogoPercorso(commessaId: number | undefined, numeroAcquirenti: number): Map<number, RiepilogoAcquirente> {
  const [mappa, setMappa] = useState<Map<number, RiepilogoAcquirente>>(new Map());
  useEffect(() => {
    if (!commessaId) return;
    // Scarta le risposte arrivate fuori ordine dopo un cambio di commessa o di numero di acquirenti.
    let attivo = true;
    // @api GET /api/percorso-acquirenti/commesse/:commessaId/riepilogo-acquirenti -> {"success":true,"data":"array"}
    apiFetch<{ success: boolean; data: RiepilogoAcquirente[] }>(`/api/percorso-acquirenti/commesse/${commessaId}/riepilogo-acquirenti`)
      .then(r => { if (attivo) setMappa(new Map(r.data.map(x => [x.acquirenteId, x]))); })
      .catch(e => {
        console.error('[RiepilogoPercorsoCommessa][useRiepilogoPercorso]', e);
        if (attivo) setMappa(new Map());
      });
    return () => { attivo = false; };
  }, [commessaId, numeroAcquirenti]);
  return mappa;
}

export function CellaPercorso({ riepilogo, acquirenteId }: { riepilogo?: RiepilogoAcquirente; acquirenteId: number }) {
  const navigate = useNavigate();
  if (!riepilogo) return <span className="bop-text-muted">—</span>;
  return (
    <div className="bop-percorso__sezione">
      <div className="bop-percorso__buoni">
        {riepilogo.origine === 'PAGINA_PUBBLICA' && <span className="bop-badge bop-badge-info">Pagina cantiere</span>}
        {riepilogo.buoni.map(b => (
          <span key={b.tipo} className={`bop-badge ${BADGE_STATO_BUONO[b.stato]}`}>{ETICHETTA_TIPO_BUONO[b.tipo]}</span>
        ))}
      </div>
      <span className="bop-text-muted">
        {riepilogo.venditoreRiferimento ? riepilogo.venditoreRiferimento.nome : 'Nessun venditore'}
        {riepilogo.prossimoAppuntamento ? ` · ${formatDataOraRoma(riepilogo.prossimoAppuntamento)}` : ''}
      </span>
      <button className="bop-btn bop-btn-secondary bop-btn-sm" onClick={() => navigate(`/commerciale/percorso/acquirenti/${acquirenteId}`)}>Scheda percorso</button>
    </div>
  );
}
